import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=063cb4f8&scoped=true&"
import script from "./QuestionsPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cb4f8",
  null
  
)

export default component.exports